import { PropsWithChildren } from "react";
import React from "react";

type DialablePhoneLinkPropsType = {
  phone: string;
  className?: string;
};
const DialablePhoneLink = ({
  children,
  phone,
  className,
}: PropsWithChildren<DialablePhoneLinkPropsType>) => (
  <a className={className} href={`tel:${phone}`} target="parent">
    {children}
  </a>
);

export default DialablePhoneLink;
